import React, { useState, useEffect } from "react";
import { getTranslations } from "../../Common/utils";

const MiniLeagueTabs = ({
  activeTab: propActiveTab = "Results",
  onTabChange = () => { },
  showPrizesTab = true,
}) => {
  const [currentTab, setCurrentTab] = useState(propActiveTab);

  useEffect(() => {
    setCurrentTab(propActiveTab);
  }, [propActiveTab]);

  const tabs = [
    {
      key: "Results",
      translationKey: "mini_league_tab_results",
      defaultText: "Results",
      disabled: false,
    },
    {
      key: "About",
      translationKey: "mini_league_tab_about",
      defaultText: "About",
      disabled: false,
    },
    {
      key: "Prizes",
      translationKey: "mini_league_tab_prizes",
      defaultText: "Prizes",
      disabled: !showPrizesTab,
    },
  ];

  const handleTabClick = (tabKey, disabled) => {
    if (disabled) return;
    setCurrentTab(tabKey);
    onTabChange(tabKey);
  };

  return (
    <div className="si-miniLeagueTabs">
      <div className="si-miniLeagueTabs__menu">
        <ul>
          {tabs.map((tab, index) => (
            <li key={index} aria-label={tab.defaultText} className={tab.disabled ? "si-disabled" : ""}>
              <button
                onClick={() => handleTabClick(tab.key, tab.disabled)}
                className={`${currentTab === tab.key ? "si-active" : ""} ${tab.disabled ? "si-disabled" : ""}`}
                aria-selected={currentTab === tab.key}
                disabled={tab.disabled}
              >
                {getTranslations(tab.translationKey, tab.defaultText)}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MiniLeagueTabs;

